import React, { useRef, useState } from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  MenuItem,
  TextField as MuiTextField,
  Theme,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import { removeSpace } from '../../../../common/logics';
import withStyles from '@material-ui/styles/withStyles';

const TextField = withStyles({
  root: {
    '& .Mui-disabled, .MuiSelect-select:focus': {
      color: 'black',
      backgroundColor: 'transparent',
    },
    '& .MuiSelect-icon.Mui-disabled': {
      display: 'none',
    },
  },
})(MuiTextField);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    input: {
      flex: 1,
    },
  }),
);

interface IDetailItem<T> {
  mutationVariableName?: keyof T;
  name: string;
  value: string | undefined | null;
  select?: boolean;
  options?: string[];
  labelAccessor?: (option: string) => string;
  editable?: boolean;
  setUserState?: React.Dispatch<React.SetStateAction<T>>;
}

const DetailItem = <T extends Object>(props: IDetailItem<T>) => {
  const {
    name,
    value,
    select = false,
    options,
    labelAccessor,
    editable,
    mutationVariableName,
    setUserState,
  } = props;
  const classes = useStyles();
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(value || '');
  const inputRef = useRef<any>(null);

  const handleFocus = () => {
    setIsEditing(true);
  };

  const setFocused = () => {
    setIsEditing(true);
    if (inputRef && inputRef.current) {
      inputRef?.current?.focus();
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (editable && mutationVariableName && setUserState) {
      setUserState((prev) => {
        return {
          ...prev,
          [mutationVariableName]: text,
        };
      });
    }
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const inputText = event.target.value;
    setText(inputText);
  };

  return (
    <>
      <Grid item xs={12} sm={2} className={classes.left}>
        <Typography className={classes.label}>{name} :</Typography>
      </Grid>
      <Grid item xs={11} sm={9} className={classes.left}>
        <TextField
          select={select}
          value={editable ? text : value}
          inputRef={inputRef}
          inputProps={{ 'aria-label': 'naked' }}
          InputProps={{ disableUnderline: true }}
          className={classes.input}
          disabled={!editable}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}>
          {options?.map((option, index) => (
            <MenuItem key={`${removeSpace(option)}-${index}`} value={option}>
              {(labelAccessor && labelAccessor(option)) || option}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={1} sm={1} className={classes.right}>
        {editable &&
          (isEditing ? (
            <SaveIcon className={classes.icon} onClick={handleBlur} />
          ) : (
            <EditIcon className={classes.icon} onClick={setFocused} />
          ))}
      </Grid>
    </>
  );
};

export default DetailItem;
